import axios from 'axios';
import { apiDomain } from '@/config';
import * as types from './types';

const actions = {
  resetState: ({ commit }) => {
    commit(types.RESET_STATE);
  },
  async fetchAgreement({ commit }, uuid) {
    commit(types.FETCH_AGREEMENT_PENDING);
    try {
      const response = await axios.get(`${apiDomain}seco/check/${uuid}`);
      commit(types.FETCH_AGREEMENT_FULFILLED, response);
      return true;
    } catch (error) {
      commit(types.FETCH_AGREEMENT_ERROR);
      return Promise.reject(error);
    }
  },
};

export default actions;
